import * as React from 'react';
import * as Styled from './Steps.styles';
import Media from '@ids/components/Media';
import { SerializedHowItWorksBlock } from '@ids/types/now-api';

export interface StepsProps {
    steps: SerializedHowItWorksBlock['stepItems'];
}

const Path = () => (
    <Styled.Line>
        <line
            x1="5"
            y1="0"
            x2="5"
            y2="99%"
            stroke="#AECCC5"
            strokeWidth="3"
            strokeLinecap="round"
            strokeDasharray="10 10"
        />
        <circle cx="5" cy="99%" r="5" fill="#AECCC5" />
    </Styled.Line>
);

const Steps = ({ steps }: StepsProps) => {
    if (!steps.length) {
        return null;
    }

    return (
        <Styled.Steps>
            <Path />
            {steps.map(({ title, contentText, idsMedia }, index) => {
                return (
                    <Styled.Step key={title} data-step={index + 1}>
                        <Styled.MediaWrapper ratio={4 / 3}>
                            <Media media={idsMedia} image={{ sizes: '(max-width: 767px) 100vw, 30vw' }} />
                        </Styled.MediaWrapper>
                        <Styled.TextWrapper>
                            <Styled.Title>{title}</Styled.Title>
                            <Styled.ContentText>{contentText}</Styled.ContentText>
                        </Styled.TextWrapper>
                    </Styled.Step>
                );
            })}
        </Styled.Steps>
    );
};

export default Steps;
